export default __webpack_public_path__ + "static/media/au-vic.920a3861.svg";